var map = {
	"./games/case-battles/jackpot1.webm": "188b",
	"./games/case-battles/jackpot2.webm": "da39",
	"./games/case-battles/jackpot3.webm": "673d",
	"./games/case-battles/tally1.webm": "553e",
	"./games/case-battles/tally2.webm": "8e35",
	"./games/case-battles/tally3.webm": "d6e1",
	"./games/case-battles/win-up.webm": "cc0e",
	"./games/case-battles/win1.webm": "bea4",
	"./games/case-battles/win2.webm": "4c8e",
	"./games/case-battles/win3.webm": "a9e6",
	"./games/cases/big_win.webm": "db66",
	"./games/cases/dud.webm": "a52b",
	"./games/cases/land.webm": "1160",
	"./games/cases/spin.webm": "db8d",
	"./games/coinflip/glow.webm": "7fc6",
	"./games/coinflip/impact1.webm": "3952",
	"./games/coinflip/impact2.webm": "d5a8",
	"./games/coinflip/impact3.webm": "08ee",
	"./games/coinflip/impact4.webm": "9a34",
	"./games/coinflip/sheen.webm": "ac5c",
	"./games/coinflip/toss.webm": "a0f2",
	"./games/dice/debris-1.webm": "8788",
	"./games/dice/debris-2.webm": "b1c6",
	"./games/dice/debris-3.webm": "42ef",
	"./games/dice/debris-4.webm": "ac95",
	"./games/dice/explosion-1.webm": "a76a",
	"./games/dice/explosion-2.webm": "ea9b",
	"./games/dice/fuse.webm": "a14b",
	"./games/dice/impact-1.webm": "59d4",
	"./games/dice/impact-2.webm": "40d6",
	"./games/dice/impact-3.webm": "4129",
	"./games/dice/impact-4.webm": "cd71",
	"./games/dice/light.webm": "f0f0",
	"./games/dice/throw-1.webm": "47fc2",
	"./games/dice/throw-2.webm": "5a4f",
	"./games/dice/throw-3.webm": "d3a8",
	"./games/wheel/loop.webm": "d51f",
	"./games/wheel/spin.webm": "d870",
	"./games/wheel/stop1.webm": "5c92",
	"./games/wheel/stop2.webm": "e6d0",
	"./games/wheel/stop3.webm": "84b1",
	"./games/wheel/tick1.webm": "65f7",
	"./games/wheel/tick2.webm": "b74a",
	"./games/wheel/tick3.webm": "6924",
	"./games/wheel/tick4.webm": "bc9c",
	"./games/wheel/win.webm": "b9a4",
	"./items/bone_1.webm": "d88a",
	"./items/bone_2.webm": "260d",
	"./items/bone_3.webm": "31c3",
	"./items/bone_4.webm": "2242",
	"./items/cloth_1.webm": "f792",
	"./items/cloth_2.webm": "9986",
	"./items/cloth_3.webm": "d262",
	"./items/cloth_4.webm": "6efe",
	"./items/gun_1.webm": "8d7e",
	"./items/gun_2.webm": "a7b0",
	"./items/gun_3.webm": "8adf",
	"./items/gun_4.webm": "ed04",
	"./items/leather_1.webm": "4621",
	"./items/leather_2.webm": "0ae8",
	"./items/leather_3.webm": "e9a3",
	"./items/leather_4.webm": "bf07",
	"./items/metal_1.webm": "ba6c",
	"./items/metal_2.webm": "deea",
	"./items/metal_3.webm": "8275",
	"./items/metal_4.webm": "0c92",
	"./items/metal_5.webm": "a1a4",
	"./items/metal_6.webm": "d7b1",
	"./items/metal_7.webm": "ed38",
	"./items/metal_8.webm": "b562",
	"./items/metal_hollow_1.webm": "2d9d",
	"./items/metal_hollow_2.webm": "aab4",
	"./items/metal_hollow_3.webm": "bda4",
	"./items/metal_hollow_4.webm": "b1ea",
	"./items/metal_sheet_1.webm": "ba0f",
	"./items/metal_sheet_2.webm": "ff01",
	"./items/metal_sheet_3.webm": "15e0",
	"./items/metal_sheet_4.webm": "b13f",
	"./items/metal_wood_1.webm": "b34c",
	"./items/metal_wood_2.webm": "759f",
	"./items/metal_wood_3.webm": "10d1",
	"./items/metal_wood_4.webm": "9c4f",
	"./items/plastic_1.webm": "5f0a",
	"./items/plastic_2.webm": "b82c",
	"./items/plastic_3.webm": "de6d",
	"./items/plastic_4.webm": "28b5",
	"./items/rubber_1.webm": "0c65",
	"./items/rubber_2.webm": "c485",
	"./items/rubber_3.webm": "257d",
	"./items/rubber_4.webm": "0f7b",
	"./items/stone_1.webm": "c5c1",
	"./items/stone_2.webm": "aa78",
	"./items/stone_3.webm": "6369",
	"./items/stone_4.webm": "f795",
	"./items/wood_1.webm": "6ba4",
	"./items/wood_2.webm": "c4f4",
	"./items/wood_3.webm": "29cb",
	"./items/wood_4.webm": "6e61",
	"./items/wood_5.webm": "f18f",
	"./items/wood_6.webm": "bd31",
	"./items/wood_7.webm": "117e",
	"./items/wood_8.webm": "9836",
	"./level_up.webm": "ee13",
	"./toast-error.webm": "d202",
	"./toast-info.webm": "42bf",
	"./toast-success.webm": "0d49",
	"./toast-warning.webm": "983c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b93";